import { useOfferingType } from '@/hooks/useOfferingType';
import { ProductQualityAudit } from './QualityAuditDashboard.product';
import { ServiceQualityAudit } from './QualityAuditDashboard.service';

/**
 * Thin router that delegates to the correct quality audit view
 * based on the selected site's offering_type.
 *
 * - 'product' (default) -> ProductQualityAudit  (original 1,849-line component)
 * - 'service'           -> ServiceQualityAudit  (service data completeness audit)
 * - 'mixed'             -> both stacked
 */
export default function QualityAuditDashboard() {
  const offeringType = useOfferingType();

  switch (offeringType) {
    case 'service':
      return <ServiceQualityAudit />;
    case 'mixed':
      return (
        <div className="space-y-8">
          <div>
            <h2 className="text-lg font-semibold mb-4">Service Quality Audit</h2>
            <ServiceQualityAudit />
          </div>
          <div>
            <h2 className="text-lg font-semibold mb-4">Product Quality Audit</h2>
            <ProductQualityAudit />
          </div>
        </div>
      );
    case 'product':
    default:
      return <ProductQualityAudit />;
  }
}
